import { RotateCcwIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { useSupportContacts } from "@/features/support";

import type { ErrorProps } from "./ErrorFallback.types";

export const Error = (props: ErrorProps) => {
  const {
    icon = "/images/server_warning.svg",
    statusCode,
    title,
    message,
    buttonAction,
    isRefreshBtn = true,
    buttonText,
  } = props;
  const { t } = useTranslation();
  const { hasContacts } = useSupportContacts();

  return (
    <div className="max-w-5xl mx-auto h-full flex flex-col items-center justify-center text-center">
      <img
        data-test-id="error-icon"
        src={icon}
        alt="Error Icon"
        className="w-36 h-36 mb-10"
      />
      <div className="w-full">
        <span
          data-test-id="error-status-code"
          className="text-muted-foreground text-sm font-semibold leading-relaxed"
        >
          {statusCode}
        </span>
        <h6
          data-test-id="error-title"
          className="text-xl font-semibold leading-relaxed my-5"
        >
          {t(title)}
        </h6>
        <p data-test-id="error-message">{t(message)}</p>
        <div className="my-8">
          <Button data-test-id="error-button" size="lg" onClick={buttonAction}>
            {isRefreshBtn && <RotateCcwIcon />}
            {isRefreshBtn ? t("retry") : t(buttonText ?? "retry")}
          </Button>
        </div>
        {hasContacts && (
          <>
            <div
              data-test-id="help-button"
              className="text-sm font-semibold leading-relaxed"
            >
              {t("participantIdHelp_subtitle")}
            </div>
            <Link
              to="/support"
              data-test-id="help-email"
              className="font-medium hover:underline"
            >
              {t("carerInvitation_visitSupport")}
            </Link>
          </>
        )}
      </div>
    </div>
  );
};
